import { Button, Col, Form, Input, Row, Space, Upload, Typography, message } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined, PhoneOutlined, MailOutlined, KeyOutlined, UserAddOutlined, StarOutlined, UploadOutlined, } from '@ant-design/icons';
import { useEffect } from 'react';
import { SearchSelect } from '../../../../../../component/Button';

const ExtraInfoStep = ({ form, schools, fetchSchools, goNext, goPrev }) => {

    useEffect(() => {
        fetchSchools();
    }, []);

    const validateFileBeforeUpload = (file) => {
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];

        const isAllowedType = allowedTypes.includes(file.type);
        if (!isAllowedType) {
            message.error('Solo se permiten archivos PDF o imágenes (JPG, PNG)');
            return Upload.LIST_IGNORE; // evita agregarlo a la lista
        }

        const isLt2M = file.size / 1024 / 1024 <= 2;
        if (!isLt2M) {
            message.error('El archivo debe pesar 2 MB o menos');
            return Upload.LIST_IGNORE;
        }
        return false;
    };

    return (
        <Row gutter={[16, 16]} align="middle" justify="center">
            <Col xs={24} sm={20}>
                <Form.Item
                    label="Nombre completo"
                    name="nombre_completo"
                    rules={[
                        { required: true, message: 'Ingresa un número de teléfono' },
                        { whitespace: true, message: 'Espacios no permitidos' },
                        { min: 5, max: 150, message: 'Mínimo 5 y.max 150 caracteres' }
                    ]}
                >
                    <Input prefix={<UserAddOutlined />} min={5} max={150} placeholder="Nombre completo" />
                </Form.Item>
            </Col>
            <Col xs={24} sm={20}>
                <Form.Item
                    label="Plantel al que perteneciste"
                    name="id_plantel"
                    rules={[
                        { required: true, message: 'Selecciona un plantel' },
                    ]}
                >
                    <SearchSelect
                        placeholder="Selecciona un plantel"
                        dataset={schools}
                        onChange={(value, option) => { 
                            form.setFieldValue('plantel', option?.title);
                        }}
                    />
                </Form.Item>
            </Col>
            <Col xs={24} sm={20}>
                <Form.Item
                    label="Plantel al que perteneciste"
                    name="plantel"
                    rules={[
                        { required: true, message: 'Selecciona un plantel' },
                    ]}
                    style={{display: 'none'}}
                >
                    <Input />
                </Form.Item>
            </Col>
            <Col xs={24} sm={20}>
                <Form.Item
                    label="Carrera que cursaste"
                    name="carrera"
                    rules={[
                        { required: true, message: 'Ingresa  la Carrera Técnica que cursaste' },
                        { whitespace: true, message: 'Espacios no permitidos' },
                        { min: 5, max: 100, message: 'Mínimo 5 y.max 150 caracteres' }
                    ]}
                >
                    <Input prefix={<StarOutlined />} min={5} max={100} placeholder="Nombre de la carrera" />
                </Form.Item>
            </Col>
            <Col xs={24} sm={20}>
                <Form.Item
                    name="documento_probatorio"
                    label="Documento que te certifique que cursaste la carrera"
                    rules={[{ required: true, message: 'Por favor carga un documento válido' }]}
                    valuePropName="fileList"
                    getValueFromEvent={(e) => Array.isArray(e) ? e : e?.fileList}
                >
                    <Upload
                        name="archivo"
                        accept=".pdf,.jpg,.jpeg,.png"
                        beforeUpload={validateFileBeforeUpload} // 👈 usamos la función aquí
                        maxCount={1}
                        multiple={false}
                        listType="text"
                    >
                        <Button icon={<UploadOutlined />}>Adjuntar archivo</Button>
                    </Upload>

                </Form.Item>

                <div style={{ marginBottom: 8 }}>
                    <Typography.Text type="secondary">
                        Puedes cargar uno de los siguientes documentos:
                    </Typography.Text>
                    <ul style={{ marginTop: 4, paddingLeft: 20 }}>
                        <li>Certificado de estudios (preferido)</li>
                        <li>Título técnico</li>
                        <li>Última boleta oficial</li>
                    </ul>
                </div>
            </Col>

            <Col xs={24} sm={20} align="center">
                <Space justify="space-evenly">
                    <Button icon={<ArrowLeftOutlined />} onClick={goPrev} style={{ marginRight: 8 }}>Atrás</Button>
                    <Button icon={<ArrowRightOutlined />} type="primary" onClick={goNext}>Continuar</Button>
                </Space>
            </Col>
        </Row>
    );
};

export default ExtraInfoStep;
